var _path;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
function SvgK1Modularity(props) {
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 76,
    height: 76,
    viewBox: "0 0 76 76",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg"
  }, props), _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M36 9v13h7.38c1.07 0 2.33.5 2.33 1.92A2.151 2.151 0 0143.38 26H36v10h-6v-3.42a6 6 0 10-12 0V36H9v31h58V9H36zm0 54H13V40h9v-7.42a2.07 2.07 0 012-2.33 2.12 2.12 0 012 2.33V40h10v6h-1.71a6 6 0 100 12H36v5zm27 0H40v-9h-5.71a2 2 0 010-4h5.64V40H45v4.08a6 6 0 0011.94 0V40h6L63 63zm0-27H53v7.42a2.121 2.121 0 01-2 2.33 2.07 2.07 0 01-2-2.33V36h-9v-6h3.4a6.142 6.142 0 006.33-6.08A5.999 5.999 0 0043.38 18H40v-5h23v23z",
    fill: "currentColor"
  })));
}
export default __webpack_public_path__ + "static/media/K1_Modularity.2a8053bb.svg";
export { SvgK1Modularity as ReactComponent };